import React from "react";
import styled, { keyframes } from "styled-components";

// Keyframes for the shimmer animation
const shimmer = keyframes`
  0% {
    background-position: -500px 0;
  }
  100% {
    background-position: 500px 0;
  }
`;

// Shimmer effect container
const ShimmerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  background: #f6f7f8;
  position: relative;
`;

// Shimmer effect element
const ShimmerElement = styled.div`
  background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
  background-size: 1000px 100%;
  animation: ${shimmer} 1.5s infinite linear;
  height: ${({ height }) => height || "100%"};
  width: 100%;
  padding: 20px;
`;

// Shimmer effect card
const ShimmerEffectCard = styled.div`
  background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
  background-size: 1000px 100%;
  animation: ${shimmer} 1.5s infinite linear;
  height: ${({ height }) => height || "100%"};
  margin: 20px;
  padding: 20px;
  border-radius: 8px;
`;

const ShimmerCard = () => {
  const cards = Array.from({ length: 12 });
  return (
    <ShimmerWrapper>
      {/* <ShimmerElement height="210px" /> */}
      <ShimmerElement height="80px" />
      <div
        style={{
          padding: "0px 20px",
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(350px, 1fr))",
        }}
      >
        {cards.map((_, index) => (
          <ShimmerEffectCard key={index} height="210px" />
        ))}
      </div>
    </ShimmerWrapper>
  );
};

export default ShimmerCard;
